import React from 'react';
import connect from "react-redux/es/connect/connect";
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import { withRouter } from 'react-router-dom'
import styles from 'common/components/style';

import DialogTitle from 'common/components/dialog/DialogTitle';
import DialogContent from 'common/components/dialog/DialogContent';

import {
  attendanceReviewQuickOpenTeacher, changeDialogOpenState
} from 'redux/admin/Actions';

class AttendanceReviewSpecifyTeacherDialog extends React.Component {
  render() {
    const { classes, matchedTeachers, attendanceReviewSpecifyTeacherDialog } = this.props;

    this.handleTeacherSelect = (teacher) => {
      this.props.attendanceReviewQuickOpenTeacher({
        teacherId: teacher.id,
        navigateFunc: (url) => {
          this.props.changeDialogOpenState({ dialogName: 'attendanceReviewSpecifyTeacherDialog', isOpen: false })
          this.props.history.push(url);
      }})
    }

    return (
      <Dialog
        aria-labelledby="course-selection-dialog-title"
        open={attendanceReviewSpecifyTeacherDialog}
        onClose={() => this.props.changeDialogOpenState({ dialogName: 'attendanceReviewSpecifyTeacherDialog', isOpen: false })}
        PaperProps={{
          style: { minWidth: '600px' }
        }}
      >
        <DialogTitle id="customized-dialog-title" onClose={() => this.props.changeDialogOpenState({ dialogName: 'attendanceReviewSpecifyTeacherDialog', isOpen: false })}>
          Multiple teachers match your account. Please select one
        </DialogTitle>

        <DialogContent className={classes.dialogContentRoot}>
          <List>
            {matchedTeachers.map(teacher => (
              <ListItem button key={teacher.id} onClick={() => this.handleTeacherSelect(teacher)}>
                <b>{teacher.fullName}</b>; SchoolTRAK Id: &nbsp;<b>{teacher.id}</b>; Skyward User Id: &nbsp;<b>{teacher.vendorUserId}</b>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    )
  }
}

const mapDispatchToProps = {
  attendanceReviewQuickOpenTeacher,
  changeDialogOpenState
};

const mapStateToProps = state => {
  return { matchedTeachers: state.admin.matchedTeachers, attendanceReviewSpecifyTeacherDialog: state.admin.dialogs.attendanceReviewSpecifyTeacherDialog };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(AttendanceReviewSpecifyTeacherDialog)));
